module.exports = __webpack_public_path__ + "img/light-light.1fa14cf9.svg";